import { ErrorCodes } from "../enums/error-code.enum";

// export interface ErrorModel {
//    code: string | ErrorCodes,
//    message: string,
// }

export class ErrorModel {

  constructor(
      public code: string | ErrorCodes,
      public message: string,
  ) { }
}
